import { CORAL_600 } from 'constants/styling/theme'
import { FC } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

interface Props {
  onRetry?: () => void
}

/**
 * Simple error fallback for assignment detail drawer renderers.
 * Designed for React Query isError states with an optional inline retry link.
 * @example
 * if (isError) return <RendererErrorState onRetry={refetch} />
 */
export const RendererErrorState: FC<Props> = ({ onRetry }) => {
  const { t } = useTranslation(['gallery'])

  return (
    <Stack alignItems="center" justifyContent="center" padding="1rem 0">
      <Typography variant="text-sm" color={CORAL_600} textAlign="center">
        {t('gallery:assignment_details.error_loading')}
      </Typography>
      {!!onRetry &&
        <Typography
          variant="text-sm"
          color={CORAL_600}
          fontWeight={700}
          textAlign="center"
          sx={{ textDecoration: 'underline', cursor: 'pointer', marginTop: '.4rem' }}
          onClick={onRetry}
        >
          {t('gallery:assignment_details.retry')}
        </Typography>
      }
    </Stack>
  )
}
